/** Mobile viewport helper — alinha com hero reels (≤1023px). */
export const MOBILE_MQ = "(max-width: 1023px)";

export function isMobileViewport() {
  if (typeof window === "undefined") return true;
  return window.matchMedia(MOBILE_MQ).matches;
}

/** Props vazias = sem animação (evita tela branca no scroll iOS). */
export const NO_MOTION = {};
